/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { Map } from 'immutable';
import { denormalize } from 'normalizr';
import * as schemas from 'data/utils/schemas';
import {
  loadingProgress,
  listLoadingProgress,
  itemsPagination,
  gatewaysItemsPagination,
  repeatersItemsPagination,
  gatewaysListLoadingProgress,
  repeatersListLoadingProgress,
  audioSnippetsLoadingProgress,
} from 'data/reducers/devices';

import createImmutableEqualSelector from 'data/utils/immutable-selector';

const getState = (state) => state.devices;

export const getEntities = (state) => getState(state).get('entities');
export const getGatewaysEntities = (state) => getState(state).get('gateways');
export const getRepeatersEntities = (state) => getState(state).get('repeaters');

export const getItemsList = createImmutableEqualSelector(getEntities, getState, (devices, state) =>
  denormalize(itemsPagination.getPageItems(state), [schemas.device], new Map({ devices })),
);

export const getGatewaysItemsList = createImmutableEqualSelector(getGatewaysEntities, getState, (gateways, state) =>
  denormalize(gatewaysItemsPagination.getPageItems(state), [schemas.gateway], new Map({ gateways })),
);

export const getRepeatersItemsList = createImmutableEqualSelector(getRepeatersEntities, getState, (repeaters, state) =>
  denormalize(repeatersItemsPagination.getPageItems(state), [schemas.repeater], new Map({ repeaters })),
);

export const getAirspaceItems = (state, airspaceId) =>
  getItemsList(state)?.filter((item) => item.getIn(['airspace', 'id']) === Number(airspaceId));

export const getItemsTotal = (state) => itemsPagination.getTotalItems(getState(state));
export const getItemsPerPage = (state) => itemsPagination.getItemsPerPage(getState(state));
export const getGatewaysItemsTotal = (state) => gatewaysItemsPagination.getTotalItems(getState(state));
export const getGatewaysItemsPerPage = (state) => gatewaysItemsPagination.getItemsPerPage(getState(state));
export const getRepeatersItemsTotal = (state) => repeatersItemsPagination.getTotalItems(getState(state));
export const getRepeatersItemsPerPage = (state) => repeatersItemsPagination.getItemsPerPage(getState(state));

export const getItemsListLoaded = (state) => listLoadingProgress.getLoaded(getState(state));
export const getItemsListLoading = (state) => listLoadingProgress.getLoading(getState(state));
export const getItemsListLoadFailed = (state) => listLoadingProgress.getLoadFailed(getState(state));
export const getGatewaysItemsListLoaded = (state) => gatewaysListLoadingProgress.getLoaded(getState(state));
export const getGatewaysItemsListLoading = (state) => gatewaysListLoadingProgress.getLoading(getState(state));
export const getGatewaysItemsListLoadFailed = (state) => gatewaysListLoadingProgress.getLoadFailed(getState(state));
export const getRepeatersItemsListLoaded = (state) => repeatersListLoadingProgress.getLoaded(getState(state));
export const getRepeatersItemsListLoading = (state) => repeatersListLoadingProgress.getLoading(getState(state));
export const getRepeatersItemsListLoadFailed = (state) => repeatersListLoadingProgress.getLoadFailed(getState(state));

export const getItemLoaded = (state) => loadingProgress.getLoaded(getState(state));
export const getItemLoading = (state) => loadingProgress.getLoading(getState(state));
export const getItemLoadFailed = (state) => loadingProgress.getLoadFailed(getState(state));

export const getItem = (state, id) => getEntities(state).get(id);

export const getAudioSnippets = (state) => getState(state).get('audioSnippets');
export const getAudioSnippetsLoaded = (state) => audioSnippetsLoadingProgress.getLoaded(getState(state));
export const getAudioSnippetsLoading = (state) => audioSnippetsLoadingProgress.getLoading(getState(state));
